import Slider from './Slider'

export default Slider



// WEBPACK FOOTER //
// ./src/legacy/components/Slider/index.js